import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import update from 'immutability-helper';
import debounce from 'lodash.debounce';
import Form from './Form';
import './GroupParentForm.scss';
import { analyticsTrack } from '../../../analyticsUtils';
var GroupParentForm = /*#__PURE__*/function (_Component) {
  function GroupParentForm(props) {
    var _this;
    _classCallCheck(this, GroupParentForm);
    _this = _callSuper(this, GroupParentForm, [props]);
    _this.state = {
      errors: [],
      answers: props.answers
    };
    _this.handleAddForm = _this.handleAddForm.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleValidation = _this.handleValidation.bind(_this);
    _this.handleDeleteForm = _this.handleDeleteForm.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleFormAndMenuUpdate = debounce(_this.handleFormAndMenuUpdate.bind(_this), 500);
    _this.renderAddButtonText = _this.renderAddButtonText.bind(_this);
    return _this;
  }
  _inherits(GroupParentForm, _Component);
  return _createClass(GroupParentForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var answers = this.state.answers;
      if (answers.length === 0) {
        this.handleAddForm();
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(value, columnName, index) {
      var answers = this.state.answers;
      var innerIndex = answers[index].findIndex(function (a) {
        return a.column_name === columnName;
      });
      var newAnswers = update(answers, _defineProperty({}, index, _defineProperty({}, innerIndex, {
        value: {
          $set: value
        }
      })));
      this.setState({
        errors: []
      });
      this.handleValidation();
      this.setState({
        answers: newAnswers
      }, this.handleFormAndMenuUpdate);
    }
  }, {
    key: "handleFormAndMenuUpdate",
    value: function handleFormAndMenuUpdate() {
      var _this$props = this.props,
        handleMenuUpdate = _this$props.handleMenuUpdate,
        onboardingQuestionnaire = _this$props.onboardingQuestionnaire;
      if (onboardingQuestionnaire) {
        this.handleSubmit();
        handleMenuUpdate(true);
      }
    }
  }, {
    key: "handleAddForm",
    value: function handleAddForm() {
      var answers = this.state.answers;
      var _this$props2 = this.props,
        childrenQuestions = _this$props2.childrenQuestions,
        onboardingQuestionnaire = _this$props2.onboardingQuestionnaire,
        userId = _this$props2.userId,
        questionKey = _this$props2.questionKey;
      var newGrouping = Object.assign([], childrenQuestions);
      newGrouping.forEach(function (_a, index) {
        newGrouping[index].value = null;
      });
      var newAnswers = update(answers, {
        $push: [newGrouping]
      });
      analyticsTrack("".concat(this.renderAddButtonText), {
        location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
        questionKey: questionKey,
        userId: userId
      });
      this.setState({
        answers: newAnswers
      });
    }
  }, {
    key: "handleDeleteForm",
    value: function handleDeleteForm(index) {
      var _this2 = this;
      var answers = this.state.answers;
      var _this$props3 = this.props,
        questionKey = _this$props3.questionKey,
        userId = _this$props3.userId,
        onboardingQuestionnaire = _this$props3.onboardingQuestionnaire;
      answers.splice(index, 1);
      analyticsTrack("Remove ".concat(questionKey), {
        location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
        questionKey: questionKey,
        userId: userId
      });
      this.setState({
        answers: answers
      }, function () {
        if (answers.length === 0) {
          _this2.handleAddForm();
        }
        _this2.setState({
          errors: _this2.handleValidation()
        });
        _this2.handleFormAndMenuUpdate();
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var answers = this.state.answers;
      var _this$props4 = this.props,
        handleChange = _this$props4.handleChange,
        questionKey = _this$props4.questionKey,
        closeModal = _this$props4.closeModal;
      var errors = this.handleValidation();
      if (errors.filter(function (e) {
        return e.length > 0;
      }).length === 0) {
        handleChange(answers, questionKey, null, false).then(function () {
          return closeModal();
        });
      } else {
        this.setState({
          errors: errors
        });
      }
    }
  }, {
    key: "handleValidation",
    value: function handleValidation() {
      var disabled = this.props.disabled;
      if (disabled) return [];
      var answers = this.state.answers;
      if (answers.length === 1) {
        var filledForm = answers[0].filter(function (qa) {
          return qa.value;
        }).length > 0;
        if (!filledForm) {
          return [];
        }
      }
      return answers.map(function (answer) {
        var error = [];
        var association = answer.find(function (a) {
          return a.question_type === 'select_one' && a.style === 'multiselect';
        });
        if (association.value === null && association.question_key !== 'education_degree_id') {
          error.push(association.column_name.replace('_id', ''));
        }
        return error;
      });
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var _this3 = this;
      var _this$props5 = this.props,
        childrenQuestions = _this$props5.childrenQuestions,
        disabled = _this$props5.disabled,
        onboardingQuestionnaire = _this$props5.onboardingQuestionnaire,
        questionKey = _this$props5.questionKey;
      var _this$state = this.state,
        answers = _this$state.answers,
        errors = _this$state.errors;
      return /*#__PURE__*/React.createElement(Fragment, null, answers.map(function (answer, index) {
        return /*#__PURE__*/React.createElement(Form, {
          questions: childrenQuestions,
          answers: answer,
          index: index,
          handleInputChange: _this3.handleInputChange,
          handleDelete: _this3.handleDeleteForm,
          errors: errors[index] || [],
          disabled: disabled,
          onboardingQuestionnaire: onboardingQuestionnaire,
          questionKey: questionKey,
          formCount: answers.length
        });
      }));
    }
  }, {
    key: "renderAddButtonText",
    value: function renderAddButtonText() {
      var questionKey = this.props.questionKey;
      var text = "Add another ".concat(questionKey);
      if (questionKey === 'education') {
        text = 'Add degree';
      } else if (questionKey === 'language') {
        text = "Add ".concat(questionKey);
      }
      return text;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props6 = this.props,
        questionKey = _this$props6.questionKey,
        disabled = _this$props6.disabled,
        onboardingQuestionnaire = _this$props6.onboardingQuestionnaire;
      return /*#__PURE__*/React.createElement("div", {
        className: "group-parent-question ".concat(questionKey, " body-text-2")
      }, this.renderForm(), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-link text-decoration-none",
        id: "add-new-item",
        onClick: function onClick() {
          return _this4.handleAddForm();
        },
        disabled: disabled
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus me-3"
      }), this.renderAddButtonText())), !onboardingQuestionnaire && /*#__PURE__*/React.createElement("div", {
        className: "buttons-bar"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "primary",
        id: "save-group-parent",
        className: "save",
        onClick: this.handleSubmit
      }, "Save")));
    }
  }]);
}(Component);
GroupParentForm.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  questionKey: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  childrenQuestions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  closeModal: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  userId: PropTypes.string.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  onboardingQuestionnaire: PropTypes.bool
};
GroupParentForm.defaultProps = {
  disabled: false,
  onboardingQuestionnaire: false
};
export default GroupParentForm;